<script>
    import {colors, player, enemies} from '../store';
	import Command from '../Command';

	let robotIntervalId = 0;
    let availableCommands = Command.randomCommands(10);

    function selectCommand (i) {
		if (robotIntervalId) {
			return;
		}
		$player.commands = [...$player.commands, availableCommands[i]];
        availableCommands = [...availableCommands.slice(0, i), ...availableCommands.slice(i + 1)];
        let commandsToRun = [];
        for (let i = 0; i < 5; i++) {
            commandsToRun = [...commandsToRun, ...$enemies, $player];
        }
		if ($player.commands.length >= 5) {
			robotIntervalId = setInterval(() => {
                if (commandsToRun.length) {
                    commandsToRun.shift().runCommand();
				} else {
					clearInterval(robotIntervalId);
					robotIntervalId = 0;
					availableCommands = Command.randomCommands(10);
					$enemies = $enemies.map(enemy => {
						enemy.commands = Command.randomCommands(5);
						return enemy;
					});
				}
			}, 500);
		}
	}
</script>

<div class="w-full h-full bg-grey-800 flex flex-wrap flex-row">
	{#each availableCommands as {symbol}, i}
		<svg class="w-1/5 sm:w-1/10 h-1/2 sm:h-full p-1" viewBox="0 0 1 1">
			<g on:click="{() => {selectCommand(i)}}">
				<rect x="0" y="0" width="1" height="1" rx=".2" fill="{$colors.blue[800]}" />
				<use xlink:href="#{symbol}" x=".1" y=".1" width=".8" height=".8" />
			</g>
		</svg>
	{/each}
</div>
